/**
 * TechnologyVersion Validation Schemas (issue #1283)
 */

import { z } from 'zod';
import { optionalBoundedText } from './shared';

export const createTechnologyVersionSchema = z.object({
  versionLabel: z
    .string()
    .min(1, 'Version label is required')
    .max(50, 'Version label must be less than 50 characters'),
  status: z.enum(['draft', 'published', 'deprecated']).optional(),
  releaseDate: z.string().optional(),
  notes: optionalBoundedText(2000, 'Notes must be less than 2000 characters'),
});

export const updateTechnologyVersionSchema = z
  .object({
    versionLabel: z
      .string()
      .min(1, 'Version label is required')
      .max(50, 'Version label must be less than 50 characters')
      .optional(),
    status: z.enum(['draft', 'published', 'deprecated']).optional(),
    releaseDate: z.string().optional(),
    notes: optionalBoundedText(2000, 'Notes must be less than 2000 characters'),
  })
  .refine((data) => Object.values(data).some((value) => value !== undefined), {
    message: 'At least one field must be updated',
  });

export type CreateTechnologyVersionFormData = z.infer<typeof createTechnologyVersionSchema>;

export type UpdateTechnologyVersionFormData = z.infer<typeof updateTechnologyVersionSchema>;
